import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  PersonFill,
  EnvelopeFill,
  Building,
  TelephoneFill,
  GeoAltFill,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import InfoRow from "./InfoRow.tsx";

import { GreenLabel, HeaderLabel } from "../Labels.tsx";

import { useHomeContext } from "../../views/Home/HomeView.context.tsx";

const ProfileFormUI: React.FC = () => {
  const { isLoading, loadingComponent, handleOpenOtpPasswordModal, profileData } = useHomeContext();
  const { t } = useTranslation();

  if (isLoading) return loadingComponent;

  return (
    <Col xs={12} sm={12} md={8} lg={6} xl={4} className="p-0">
      <div className="m-4 profile">
        <HeaderLabel textAlign="left">{t("profile.title")}</HeaderLabel>

        <div className="p-4 rounded-4 d-flex flex-column card">
          <InfoRow
            icon={<PersonFill size={16} />}
            label={t("profile.fullName")}
            value={profileData?.name}
          />

          <InfoRow
            icon={<EnvelopeFill size={16} />}
            label={t("profile.email")}
            value={profileData?.email}
          />

          <InfoRow
            icon={<Building size={16} />}
            label={t("profile.company")}
            value={profileData?.company}
          />

          <InfoRow
            icon={<TelephoneFill size={16} />}
            label={t("profile.phone")}
            value={profileData?.phone}
          />

          <InfoRow
            icon={<GeoAltFill size={16} />}
            label={t("profile.country")}
            value={profileData?.country}
          />

          <Row className="mt-2">
            <GreenLabel onClick={handleOpenOtpPasswordModal} margin="0">
              {t("profile.changePassword")}
            </GreenLabel>
          </Row>
        </div>
      </div>
    </Col>
  );
};

export default ProfileFormUI;
